import { useEditMode } from '@/contexts/EditModeContext';
import { Button } from './ui/button';
import { Edit, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from '@/hooks/use-toast';

export const EditModeToggle = () => {
  const { isEditMode, setIsEditMode, isAdmin, loading } = useEditMode();

  const handleToggle = () => {
    const newState = !isEditMode;
    setIsEditMode(newState);
    
    if (newState) {
      toast({
        title: "✏️ Edit Mode aktiveret!",
        description: "Hover over tekstfelter for at redigere dem. Enter = Gem, ESC = Annuller",
        duration: 5000,
      });
    }
  };

  if (loading || !isAdmin) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        className="fixed bottom-24 right-6 z-40 flex flex-col items-end gap-2"
      >
        {isEditMode && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-primary text-primary-foreground px-3 py-1.5 rounded-full text-xs font-semibold shadow-large"
          >
            Edit Mode ON
          </motion.div>
        )}
        <Button
          onClick={handleToggle}
          size="lg"
          className={`rounded-full shadow-large transition-smooth ${
            isEditMode 
              ? 'bg-destructive hover:bg-destructive/90' 
              : 'bg-primary hover:bg-primary-dark'
          }`}
        >
          {isEditMode ? (
            <>
              <X className="h-5 w-5 mr-2" />
              Exit Edit
            </>
          ) : (
            <>
              <Edit className="h-5 w-5 mr-2" />
              Edit Mode
            </>
          )}
        </Button>
      </motion.div>
    </AnimatePresence>
  );
};
